import { ReactNode } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useIsMobile } from '../hooks/useMediaQuery'

type Props = {
  children: ReactNode
  label?: string
}

// Gruppo di pulsanti secondari: su desktop mostrati in riga così come sono,
// su mobile raccolti in un menu a tendina per non occupare spazio
export default function MobileActionsMenu({ children, label = 'Azioni' }: Props) {
  const isMobile = useIsMobile()

  if (!isMobile) {
    return <>{children}</>
  }

  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center bg-white text-secondary">
        <span className="material-icons me-1" style={{ fontSize: 18 }}>
          more_vert
        </span>
        {label}
      </Dropdown.Toggle>
      <Dropdown.Menu className="mobile-actions-menu p-1">{children}</Dropdown.Menu>
    </Dropdown>
  )
}
